var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-page header-other"},[_c('a',{staticClass:"btn-back",on:{"click":_vm.clickBack}},[_c('img',{attrs:{"src":require("@/assets/icon-back.svg")}})]),_c('span',[_vm._v(_vm._s(_vm.titleName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }